<template>
    <div class="off--block-main">
        <div class="field is-horizontal">
            <div class="field-label"><label class="label">CTOT</label></div>
            <div class="field-body">
                <div class="field is-expanded">
                    <div class="field has-addons">
                        <p class="control is-expanded">
                            <datepicker
                                    :config="{ dateFormat:'H:i',enableTime:true ,noCalendar:true,time_24hr:true}" v-if="InputsObject.IF.ctot" v-model="InputsObject.IF.ctot" disabled/>
                        </p>
                        <p class="control">
                           <span>
                           <a class="button"><i class="fa fa-clock"></i></a>
                           </span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="field is-horizontal">
            <div class="field-label"><label class="label">DCT(Door Close Time)</label></div>
            <div class="field-body">
                <div class="field is-expanded">
                    <div class="field has-addons">
                        <p class="control is-expanded">
                            <datepicker
                                    :config="{ dateFormat:'H:i',enableTime:true ,noCalendar:true,time_24hr:true}" v-if="InputsObject.IF.dct" v-model="InputsObject.IF.dct" disabled/>
                        </p>
                        <p class="control">
                           <span>
                           <a class="button"><i class="fa fa-clock"></i></a>
                           </span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="title is-size-5 ">Times</div>

        <div class="field is-horizontal">
            <div class="field-label"><label class="label">Off Block Time</label></div>
            <div class="field-body">
                <div class="field is-expanded">
                    <div class="field has-addons">
                        <p class="control is-expanded">
                            <datepicker
                                    :config="{ dateFormat:'H:i',enableTime:true ,noCalendar:true,time_24hr:true}" v-if="InputsObject.IF.offBlockTime" v-model="InputsObject.IF.offBlockTime" disabled/>
                        </p>
                        <p class="control">
                           <span>
                           <a class="button"><i class="fa fa-clock"></i></a>
                           </span>
                        </p>
                    </div>
                </div>
            </div>
        </div>

        <div class="field is-horizontal">
            <div class="field-label"><label class="label">Take Off Time</label></div>
            <div class="field-body">
                <div class="field is-expanded">
                    <div class="field has-addons">
                        <p class="control is-expanded">
                            <datepicker :config="{ dateFormat:'H:i',enableTime:true ,noCalendar:true,time_24hr:true}" v-if="InputsObject.IF.takeOffTime" v-model="InputsObject.IF.takeOffTime" disabled/>
                        </p>
                        <p class="control">
                           <span>
                           <a class="button"><i class="fa fa-clock"></i></a>
                           </span>
                        </p>
                    </div>
                </div>
            </div>
        </div>



        <div v-if="InputsObject.IF.delays">
<!--            v-for="ipaddevice in this.paginate" :key="ipaddevice.id"-->
<!--            <div class="notification is-white" v-for="(NotamInfo,idx) in NotamList" :key="idx">-->
            <div v-for="(reasonOfDelay,idx) in InputsObject.IF.delays" :key="idx">
                <div class="title is-size-5"><p>Delay Code </p></div>
                <div class="field is-horizontal">
                    <div class="field-label"><label class="label">Reason Of Delay</label></div>
                    <div class="field-body">
                        <div class="field is-expanded">
                            <div class="field has-addons">
                                <div class="control is-expanded">
                                    <div class="field-body">
                                        <div class="field">
                                            <div class="control">
                                                <div v-if="reasonOfDelay !== undefined">
                                                    <input class="input" type="text" placeholder="-" v-if="reasonOfDelay.delayCode" v-model="reasonOfDelay.delayCode" readonly>
                                                    <input class="input" type="text" placeholder="-" v-if="reasonOfDelay.reason" v-model="reasonOfDelay.reason" readonly>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="field is-horizontal">
                    <div class="field-label"><label class="label">Delay Time  (Minutes)</label></div>
                    <div class="field-body">
                        <div class="field is-expanded">
                            <div class="field has-addons">
                                <div v-if="reasonOfDelay !== undefined" class="control">
                                    <input class="input" type="number" placeholder="MM" v-if="reasonOfDelay.delayTime" v-model="reasonOfDelay.delayTime" readonly>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

<!--        <div class="title is-size-5"><p>Delay Code 1</p></div>-->
<!--        <div class="field is-horizontal">-->
<!--            <div class="field-label"><label class="label">Reason Of Delay</label></div>-->
<!--            <div class="field-body">-->
<!--                <div class="field is-expanded">-->
<!--                    <div class="field has-addons">-->
<!--                        <div class="control is-expanded" v-if="InputsObject.IF.delays">-->
<!--                            <div class="field-body">-->
<!--                                <div class="field">-->
<!--                                    <div class="control">-->
<!--                                        <input class="input" type="text" placeholder="-" v-if="InputsObject.IF.delays[0].delayCode" v-model="InputsObject.IF.delays[0].delayCode" readonly>-->
<!--                                        <input class="input" type="text" placeholder="-" v-if="InputsObject.IF.delays[0].reason" v-model="InputsObject.IF.delays[0].reason" readonly>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
<!--        </div>-->

<!--        <div class="field is-horizontal">-->
<!--            <div class="field-label"><label class="label">Delay Time 1 (Minutes)</label></div>-->
<!--            <div class="field-body">-->
<!--                <div class="field is-expanded">-->
<!--                    <div class="field has-addons">-->
<!--                        <div class="control" v-if="InputsObject.IF.delays">-->
<!--                            <input class="input" type="number" placeholder="MM" v-if="InputsObject.IF.delays[0].delayTime" v-model="InputsObject.IF.delays[0].delayTime" readonly>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
<!--        </div>-->

<!--        <div class="title is-size-5"><p>Delay Code 2</p></div>-->
<!--        <div class="field is-horizontal">-->
<!--            <div class="field-label"><label class="label">Reason Of Delay</label></div>-->
<!--            <div class="field-body">-->
<!--                <div class="field is-expanded">-->
<!--                    <div class="field has-addons">-->
<!--                        <div class="control is-expanded" v-if="InputsObject.IF.delays">-->
<!--                                <input class="input" type="text" placeholder="&#45;&#45;" v-if="InputsObject.IF.delays[1].delayCode" v-model="InputsObject.IF.delays[1].delayCode" readonly>-->
<!--                                <input class="input" type="text" placeholder="-"  v-if="InputsObject.IF.delays[1].reason" v-model="InputsObject.IF.delays[1].reason" readonly>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
<!--        </div>-->

<!--        <div class="field is-horizontal">-->
<!--            <div class="field-label"><label class="label">Delay Time 2 (Minutes)</label></div>-->
<!--            <div class="field-body">-->
<!--                <div class="field is-expanded">-->
<!--                    <div class="field has-addons">-->
<!--                        <div class="control" v-if="InputsObject.IF.delays">-->
<!--                            <input class="input" type="number" placeholder="MM" v-if="InputsObject.IF.delays[1].delayTime" v-model="InputsObject.IF.delays[1].delayTime" readonly>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
<!--        </div>-->

<!--        <div class="title is-size-5"><p>Delay Code 3</p></div>-->
<!--        <div class="field is-horizontal">-->
<!--            <div class="field-label"><label class="label">Reason Of Delay</label></div>-->
<!--            <div class="field-body">-->
<!--                <div class="field is-expanded">-->
<!--                    <div class="field has-addons">-->
<!--                        <div class="control is-expanded" v-if="InputsObject.IF.delays">-->
<!--                                <input class="input" type="text" placeholder="&#45;&#45;" v-if="InputsObject.IF.delays[2].delayCode" v-model="InputsObject.IF.delays[2].delayCode" readonly>-->
<!--                                <input class="input" type="text" placeholder="&#45;&#45;" v-if="InputsObject.IF.delays[2].reason" v-model="InputsObject.IF.delays[2].reason" readonly>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
<!--        </div>-->

<!--        <div class="field is-horizontal">-->
<!--            <div class="field-label"><label class="label">Delay Time 3 (Minutes)</label></div>-->
<!--            <div class="field-body">-->
<!--                <div class="field is-expanded">-->
<!--                    <div class="field has-addons" v-if="InputsObject.IF.delays">-->
<!--                        <div class="control">-->
<!--                            <input class="input" type="number" placeholder="MM" v-if="InputsObject.IF.delays[2].delayTime" v-model="InputsObject.IF.delays[2].delayTime" readonly>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
<!--        </div>-->






        <div class="title is-size-5"><p>Total Delay</p></div>

        <div class="field is-horizontal">
            <div class="field-label"><label class="label">Total Delay (Minutes)</label></div>
            <div class="field-body">
                <div class="field is-expanded">
                    <div class="field has-addons">
                        <div class="control">
                            <input class="input" type="text" v-if="TotalDelayTime" v-model="TotalDelayTime" disabled>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="title is-size-5"><p>De-/Anti-Icing</p></div>

        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Type</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <div class="control" v-if="InputsObject.IF.antiIcings">
                        <input class="input" type="text" placeholder="-" v-if="InputsObject.IF.antiIcings[0].type" v-model="InputsObject.IF.antiIcings[0].type" readonly>
                    </div>
                </div>
            </div>
        </div>

        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">QTY(L)</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <div class="control" v-if="InputsObject.IF.antiIcings">
                        <input class="input" type="text" placeholder="L" v-if="InputsObject.IF.antiIcings[0].qty" v-model="InputsObject.IF.antiIcings[0].qty" readonly>
                    </div>
                </div>
            </div>
        </div>

        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Mix Ration % Water</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <div class="control" v-if="InputsObject.IF.antiIcings">
                        <input class="input" type="text" placeholder="-" v-if="InputsObject.IF.antiIcings[0].mixRationWater" v-model="InputsObject.IF.antiIcings[0].mixRationWater" readonly>
                    </div>
                </div>
            </div>
        </div>

        <div class="field is-horizontal">
            <div class="field-label"><label class="label">Time Started</label></div>
            <div class="field-body">
                <div class="field is-expanded">
                    <div class="field has-addons">
                        <p class="control is-expanded" v-if="InputsObject.IF.antiIcings">
                            <datepicker
                                    :config="{ dateFormat:'H:i',enableTime:true ,noCalendar:true,time_24hr:true}" v-if="InputsObject.IF.antiIcings[0].timeStarted" v-model="InputsObject.IF.antiIcings[0].timeStarted" disabled/>
                        </p>
                        <p class="field">
                           <span>
                           <a class="button"><i class="fa fa-clock"></i></a>
                           </span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="title is-size-5"><p>De-/Anti-Icing 2</p></div>

        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Type</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <div class="control" v-if="InputsObject.IF.antiIcings">
                        <input class="input" type="text" placeholder="-" v-if="InputsObject.IF.antiIcings[1].type" v-model="InputsObject.IF.antiIcings[1].type" readonly>
                    </div>
                </div>
            </div>
        </div>

        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">QTY(L)</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <div class="control" v-if="InputsObject.IF.antiIcings">
                        <input class="input" type="text" placeholder="L" v-if="InputsObject.IF.antiIcings[1].qty" v-model="InputsObject.IF.antiIcings[1].qty" readonly>
                    </div>
                </div>
            </div>
        </div>

        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Mix Ration % Water</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <div class="control" v-if="InputsObject.IF.antiIcings">
                        <input class="input" type="text" placeholder="-" v-if="InputsObject.IF.antiIcings[1].mixRationWater" v-model="InputsObject.IF.antiIcings[1].mixRationWater" readonly>
                    </div>
                </div>
            </div>
        </div>

        <div class="field is-horizontal">
            <div class="field-label"><label class="label">Time Started</label></div>
            <div class="field-body">
                <div class="field is-expanded">
                    <div class="field has-addons">
                        <p class="control is-expanded" v-if="InputsObject.IF.antiIcings">
                            <datepicker
                                    :config="{ dateFormat:'H:i',enableTime:true ,noCalendar:true,time_24hr:true}" v-if="InputsObject.IF.antiIcings[1].timeStarted" v-model="InputsObject.IF.antiIcings[1].timeStarted" disabled/>
                        </p>
                        <p class="field">
                           <span>
                           <a class="button"><i class="fa fa-clock"></i></a>
                           </span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Datepicker from 'vue-bulma-datepicker'
    import {loadingMixin} from "../../../utils/mixins";
    import {mapState} from "vuex";

    export default {
        name: "OffBlock",
        mixins: [loadingMixin],
        components: {
            Datepicker
        },

        computed : {
            ...mapState("ipadmain",[ "selectedFlightItems","EFF_Json_Data","WR_Json_Data","AttachmentsJson","OCCSelfVersions_VS_IPADLastKnownVersions","LastInputsJson","InputsObject"]),

            TotalDelayTime : {
                get(){
                    var dt0 = 0;
                    // var dt1 = 0;
                    // var dt2 = 0;

                    // if(this.InputsObject.IF.delays== null || this.InputsObject.IF.delays.length == 0)
                    // {
                    //     return;
                    // }
                    if( this.InputsObject.IF.delays) {
                        console.log();
                    }
                    else
                    {
                        return;
                    }

                    for (var reasonofDelay of this.InputsObject.IF.delays) {
                        if(reasonofDelay.delayTime ===undefined)
                        {
                            continue
                        }
                        dt0 += parseInt(reasonofDelay.delayTime,10);
                    }

                    // if(this.InputsObject.IF.delays[0].delayTime)
                    // {
                    //     dt0 = parseInt(this.InputsObject.IF.delays[0].delayTime,10);
                    // }
                    // if(this.InputsObject.IF.delays[1].delayTime)
                    // {
                    //     dt1 = parseInt(this.InputsObject.IF.delays[1].delayTime,10);
                    // }
                    // if(this.InputsObject.IF.delays[2].delayTime)
                    // {
                    //     dt2 = parseInt(this.InputsObject.IF.delays[2].delayTime,10);
                    // }

                    return dt0

                }
            }

        },

        methods: {

        }
    }
</script>

<style scoped>
    .off--block-main {
        margin-left: 5px;
    }

    .title {
        padding: 10px;
        background-color: #b5b5b53d;
    }

    .input {
        width: 300px;
    }

    .label {
        width: 300px;
        background-color: white;
        height: 35px;
        padding: 5px;
    }

    .button {
        margin-left: -280px;
    }

    .save-button {
        max-resolution: res;
        margin-left: -174px;
    }
</style>
